/**
 * Utilidades para manejo de clientes
 */

/**
 * Función utilitaria para obtener el ID del cliente de forma robusta
 * @param {Object} client - Objeto cliente
 * @returns {string|null} ID del cliente o null si no existe
 */
export const getClientId = (client) => {
  if (!client) {
    console.warn('Cliente no definido:', client);
    return null;
  }
  
  const id = client.id || client._id;
  
  if (!id) {
    console.warn('Cliente sin ID válido:', client);
    return null;
  }
  
  return typeof id === 'string' ? id : id.toString();
};

/**
 * Validar si un cliente tiene los campos requeridos
 * @param {Object} client - Objeto cliente
 * @returns {boolean} true si el cliente es válido
 */
export const isValidClient = (client) => {
  if (!client) return false;
  
  const requiredFields = ['name', 'email'];
  return requiredFields.every(field => 
    client[field] && typeof client[field] === 'string' && client[field].trim() !== ''
  );
};

/**
 * Formatear información del cliente para mostrar
 * @param {Object} client - Objeto cliente
 * @returns {Object} Cliente formateado
 */
export const formatClientForDisplay = (client) => {
  if (!client) return {};
  
  return {
    ...client,
    id: getClientId(client),
    displayName: client.name || 'Sin nombre',
    displayEmail: client.email || 'Sin email',
    displayPhone: client.phone || 'No especificado',
    displayAddress: client.address || 'No especificado',
    displayContact: client.contactPerson || 'No especificado',
    statusText: client.isActive ? 'Activo' : 'Inactivo',
    statusClass: client.isActive ? 'badge-success' : 'badge-secondary'
  };
}; 